(function () {
  var reviewObservers = new WeakMap();
  var reviewPaginationStates = new WeakMap();
  var summaryObservers = new WeakMap();
  var emptyReviewObservers = new WeakMap();

  function initEmptyReviewState(root) {
    var summary = root.querySelector('#review_main_contents');
    var details = root.querySelector('#review_contents');
    if (!summary || !details || emptyReviewObservers.has(summary)) return;

    function update() {
      var widget = summary.querySelector('.reviewWidget_inner');
      var writeButton = widget && widget.querySelector('.uKomiWidgetWriteReviewBtn-btn');
      var askButton = widget && widget.querySelector('.uKomiWidgetAskQuestionBtn-btn');
      if (!writeButton || !askButton) return;

      var countElements = widget.querySelectorAll('.review-widget-summary-container .reviewNumber');
      var countText = countElements.length ? countElements[countElements.length - 1].textContent : '';
      var countMatch = countText.match(/([\d,]+)\s*件/);
      var count = countMatch ? Number(countMatch[1].replace(/,/g, '')) : null;
      var hasReviews = !!summary.querySelector('.u-komi-review-section .singleReview') ||
        !!details.querySelector('.l_note.review .u-komi-review-section .singleReview');
      var emptyNotice = summary.querySelector('.u-komi-review-section .uKomiNoReviewsTextContainer') ||
        details.querySelector('.l_note.review .u-komi-review-section .uKomiNoReviewsTextContainer');
      var isEmpty = !hasReviews && (count === 0 || (count === null && !!emptyNotice));

      summary.classList.toggle('is-review-empty', isEmpty);
      details.classList.toggle('is-review-empty', isEmpty);
    }

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        update();
      });
    });
    observer.observe(summary, { childList: true, subtree: true, characterData: true });
    observer.observe(details, { childList: true, subtree: true });
    emptyReviewObservers.set(summary, observer);
    update();
  }

  function initSummaryLabels(root) {
    var summary = root.querySelector('#review_main_contents');
    if (!summary || summaryObservers.has(summary)) return;

    function normalizeSummaryQuestions() {
      summary.querySelectorAll('.summaryCustomRating .customRatingAns').forEach(function (group) {
        var seen = new Set();
        group.querySelectorAll(':scope > .singleQueAns').forEach(function (answer) {
          var label = answer.querySelector('.custQue');
          if (!label) return;
          var text = label.textContent.trim();
          if (label.textContent !== text) label.textContent = text;
          var key = text.replace(/\s/g, '');
          if (!key) return;
          if (seen.has(key)) answer.remove();
          else seen.add(key);
        });
      });
    }

    var observer = new MutationObserver(normalizeSummaryQuestions);
    observer.observe(summary, { childList: true, characterData: true, subtree: true });
    summaryObservers.set(summary, observer);
    normalizeSummaryQuestions();
  }

  function initReviewLayout(root) {
    var section = root.querySelector('#review_contents');
    if (!section || section.dataset.reviewLayoutBound === 'true') return;
    section.dataset.reviewLayoutBound = 'true';
    var pagination = { page: 1, signature: null, pending: 0, target: null, timer: null };
    reviewPaginationStates.set(section, pagination);

    function isCursorDisabled(button) {
      return !button || button.classList.contains('ukomi-cursor-disabled') || !button.dataset.cursor;
    }

    function totalReviewPages() {
      var count = document.querySelector('#review_main_contents .review-widget-summary-container .reviewNumber:last-child');
      var match = count && count.textContent.match(/\d+/);
      return match ? Math.ceil(Number(match[0]) / 3) : null;
    }

    function renderPagination(nav) {
      var next = nav.querySelector('.ukomi-cursor-next');
      var prev = nav.querySelector('.ukomi-cursor-prev');
      if (!next || !prev) return;
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', 'レビューのページ切り替え');

      [prev, next].forEach(function (button) {
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', isCursorDisabled(button) ? '-1' : '0');
        button.setAttribute('aria-disabled', isCursorDisabled(button) ? 'true' : 'false');
        button.setAttribute('aria-label', button === prev ? '前のレビュー' : '次のレビュー');
      });

      var pages = nav.querySelector('.product-review-pages');
      if (!pages) {
        pages = document.createElement('div');
        pages.className = 'product-review-pages';
        pages.setAttribute('role', 'group');
        pages.setAttribute('aria-label', 'レビューのページ');
        nav.appendChild(pages);
      }

      var total = totalReviewPages() || pagination.page + (isCursorDisabled(next) ? 0 : 1);
      total = Math.max(pagination.page, total);
      if (isCursorDisabled(next)) total = Math.min(total, pagination.page);
      var start = Math.max(1, Math.min(pagination.page - 2, total - 4));
      var end = Math.min(total, start + 4);
      var key = start + ':' + end + ':' + pagination.page;
      if (pages.dataset.pageRange === key) return;

      var buttons = document.createDocumentFragment();
      for (var page = start; page <= end; page += 1) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-review-page' + (page === pagination.page ? ' is-active' : '');
        button.dataset.reviewPage = String(page);
        button.textContent = String(page);
        button.setAttribute('aria-label', 'レビュー ' + page + ' ページ目');
        if (page === pagination.page) button.setAttribute('aria-current', 'page');
        buttons.appendChild(button);
      }
      pages.replaceChildren(buttons);
      pages.dataset.pageRange = key;
    }

    function advancePagination() {
      if (pagination.target === null || pagination.pending) return;
      if (pagination.target === pagination.page) {
        pagination.target = null;
        return;
      }
      var direction = pagination.target > pagination.page ? 1 : -1;
      var selector = direction > 0 ? '.ukomi-cursor-next' : '.ukomi-cursor-prev';
      var button = section.querySelector('.l_note.review .ReviewWidget_pagination ' + selector);
      if (isCursorDisabled(button)) {
        pagination.target = null;
        return;
      }
      button.click();
    }

    function decoratePagination() {
      var list = section.querySelector('.l_note.review .loadedReviews');
      var first = list && list.querySelector(':scope > .singleReview');
      var nav = section.querySelector('.l_note.review .ReviewWidget_pagination.ukomi-cursor-nav');
      if (!first || !nav) return;

      var signature = first.dataset.code || first.textContent.trim().slice(0, 80);
      if (pagination.signature === null) {
        pagination.signature = signature;
      } else if (pagination.signature !== signature) {
        pagination.signature = signature;
        if (pagination.pending) {
          pagination.page = Math.max(1, pagination.page + pagination.pending);
          pagination.pending = 0;
          clearTimeout(pagination.timer);
          pagination.timer = null;
        } else {
          pagination.page = 1;
          pagination.target = null;
        }
      }
      renderPagination(nav);
      advancePagination();
    }

    section.addEventListener('click', function (event) {
      var pageButton = event.target.closest('.product-review-page');
      if (pageButton && section.contains(pageButton)) {
        event.preventDefault();
        event.stopPropagation();
        pagination.target = Number(pageButton.dataset.reviewPage);
        advancePagination();
        return;
      }

      var cursor = event.target.closest('.l_note.review .ukomi-cursor-btn');
      if (cursor && !isCursorDisabled(cursor)) {
        pagination.pending = cursor.classList.contains('ukomi-cursor-next') ? 1 : -1;
        clearTimeout(pagination.timer);
        pagination.timer = setTimeout(function () {
          pagination.pending = 0;
          pagination.target = null;
        }, 10000);
      }

      if (event.target.closest('.l_note.review .reviewSortingSection')) {
        pagination.target = null;
      }
    }, true);

    section.addEventListener('keydown', function (event) {
      var cursor = event.target.closest('.l_note.review .ukomi-cursor-btn');
      if (cursor && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        if (!isCursorDisabled(cursor)) cursor.click();
      }
    });

    function decorateReviews() {
      var reviewSection = section.querySelector('.l_note.review .u-komi-review-section');
      var sorting = reviewSection && reviewSection.querySelector('.reviewSortingSection');
      if (sorting && !sorting.closest('.product-review-sort')) {
        var sortDisclosure = document.createElement('details');
        sortDisclosure.className = 'product-review-sort';
        var sortSummary = document.createElement('summary');
        sortSummary.textContent = '絞り込み・並べ替え';
        sorting.parentNode.insertBefore(sortDisclosure, sorting);
        sortDisclosure.appendChild(sortSummary);
        sortDisclosure.appendChild(sorting);
      }

      section.querySelectorAll('.l_note.review .singleReview:not([data-review-layout])').forEach(function (review) {
        review.dataset.reviewLayout = 'true';

        var answers = {};
        review.querySelectorAll('.singleReview_CustomQue > .singleQueAns').forEach(function (answer) {
          var label = answer.querySelector('.custQue');
          var value = answer.querySelector('.custAnd');
          if (label && value) answers[label.textContent.replace(/[:：\s]/g, '')] = value.textContent.trim();
        });

        var details = [answers['年齢'] && answers['年齢'].replace(/～$/, ''), answers['サイズ'], answers['体型']].filter(Boolean);
        var reviewer = review.querySelector('.singleReview_name > span:first-child');
        var header = review.querySelector('.singleReview_header_right');
        if (header) {
          var meta = document.createElement('span');
          meta.className = 'product-review-card__meta';
          meta.textContent = details.join('・') || (reviewer && reviewer.textContent.trim()) || '';
          header.appendChild(meta);
        }

        var date = review.querySelector('.singleReview_header_date');
        if (date) date.textContent = date.textContent.trim().replace(/-/g, '.');

        var replyHeading = review.querySelector('.singleReview_commentHead');
        if (replyHeading) replyHeading.textContent = 'ショップからの返信';
      });

      decoratePagination();
    }

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        decorateReviews();
      });
    });
    observer.observe(section, { childList: true, subtree: true });
    reviewObservers.set(section, observer);
    decorateReviews();
  }

  initSummaryLabels(document);
  initEmptyReviewState(document);
  initReviewLayout(document);
  document.addEventListener('shopify:section:load', function (event) {
    initSummaryLabels(event.target);
    initEmptyReviewState(event.target);
    initReviewLayout(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var summary = event.target.querySelector('#review_main_contents');
    var summaryObserver = summary && summaryObservers.get(summary);
    if (summaryObserver) summaryObserver.disconnect();
    var emptyReviewObserver = summary && emptyReviewObservers.get(summary);
    if (emptyReviewObserver) emptyReviewObserver.disconnect();
    var section = event.target.querySelector('#review_contents');
    var observer = section && reviewObservers.get(section);
    if (observer) observer.disconnect();
    var pagination = section && reviewPaginationStates.get(section);
    if (pagination) clearTimeout(pagination.timer);
  });
})();
